<template>
  <section class="influencer-list">

    <el-breadcrumb>
      <el-breadcrumb-item>Marketing</el-breadcrumb-item>
      <el-breadcrumb-item><b>Parceiros</b></el-breadcrumb-item>
    </el-breadcrumb>

    <snowflake-search-list ref="searchList" context="influencer" :service="influencerService" :operations="false">
      <template slot="tableRows">

        <!-- ID -->
        <el-table-column prop="id" :label="$t('influencer.id')" width="60" sortable></el-table-column>

        <!-- Tipo -->
        <el-table-column column-key="type" prop="type" label="Tipo" width="120" :filters="typeFilters">
          <template slot-scope="scope">
            <span>{{ types[scope.row.type] ?? scope.row.type }}</span>
          </template>
        </el-table-column>

        <!-- Name -->
        <el-table-column prop="name" :label="$t('influencer.name')" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{ `${scope.row.firstName} ${scope.row.lastName}` }}</span>
          </template>
        </el-table-column>

        <!-- E-mail -->
        <el-table-column prop="email" :label="$t('influencer.email')" :show-overflow-tooltip="true" sortable>
        </el-table-column>

        <!-- CPF -->
        <el-table-column prop="cpf" :label="$t('influencer.cpf')" :show-overflow-tooltip="true">
        </el-table-column>

        <!-- Active -->
        <el-table-column column-key="active" prop="active" :label="$t('influencer.active')" width="120" :filters="yesNoFilters" sortable>
          <template slot-scope="scope">
            {{fromBool(scope.row.active)}}
          </template>
        </el-table-column>

        <!-- Affiliate -->
        <el-table-column column-key="affiliate" prop="affiliate" :label="$t('influencer.affiliate')" width="120" :filters="yesNoFilters" sortable>
          <template slot-scope="scope">
            {{fromBool(scope.row.affiliate)}}
          </template>
        </el-table-column>

        <el-table-column width="140" align="center">
          <template slot="header">
          <el-dropdown trigger="click" @command="handleMenuCommand">
            <el-button size="medium" class="el-dropdown-link">
              {{ "Ações" }}<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="import">Importar parceiros</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          </template>
          <template slot-scope="scope">
            <router-link :to="{ name: 'influencer-detail', params: { id: scope.row.id } }">
              <el-button
                size="small"
                type="primary"
                plain
                icon="el-icon-edit"></el-button>

            </router-link>
          </template>
        </el-table-column>

      </template>
    </snowflake-search-list>

    <ImportInfluencers :visible.sync="importInfluencersVisible" @imported="reload" />

  </section>
</template>

<script>
import { default as InfluencerService, types } from '@/services/influencer/InfluencerService';
import SnowflakeSearchList from '@/components/list/SearchList.vue';
import ImportInfluencers from '@/views/marketing/influencer/actions/ImportInfluencers.vue';


const yesNoFilters = [
  { text: 'Sim', value: true },
  { text: 'Não', value: false },
];

export default {
  name: 'influencer-list',
  components: {
    SnowflakeSearchList,
    ImportInfluencers,
  },
  data() {
    return {
      influencerService: InfluencerService,
      yesNoFilters,
      types,
      importInfluencersVisible: false
    };
  },
  computed: {
    typeFilters() {
      return Object.entries(this.types).map(([value, text]) => ({ text, value }));
    },
  },
  methods: {
    reload() {
      this.$refs.searchList.reload();
    },
    handleMenuCommand(command) {
      switch(command) {
        default:
          this.importInfluencersVisible = !this.importInfluencersVisible;
          break;
      }
    },
    fromBool(value) {
      return value ? this.$t('coupon.activeTrue') : this.$t('coupon.activeFalse');
    },
  }
};
</script>
